import styled from 'styled-components';
const StyledZeroState = styled.div.withConfig({
  displayName: "StyledZeroState",
  componentId: "sc-105eyr3-0"
})(["margin-top:150px;display:flex;flex-direction:column;align-items:center;width:100%;"]);
export default StyledZeroState;